<app-header></app-header>
<app-lingking-group></app-lingking-group>
<!-- 主內容 -->

<router-outlet></router-outlet>

<app-footer></app-footer>



<h1 *ngIf="(isNotTop|async)" class="backtoTOP" (click)="gotop()">
  <i class="far fa-arrow-alt-circle-up"></i>
</h1>
